export default __webpack_public_path__ + "static/media/Londres.c382cf3d.jpg";